import { render, staticRenderFns } from "./myTraining_new.vue?vue&type=template&id=74fed24b&scoped=true"
import script from "./myTraining_new.vue?vue&type=script&lang=js"
export * from "./myTraining_new.vue?vue&type=script&lang=js"
import style0 from "./myTraining_new.vue?vue&type=style&index=0&id=74fed24b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74fed24b",
  null
  
)

export default component.exports